export default __webpack_public_path__ + "static/media/transunion.0f2f682e.svg";